import ReactLoading from 'react-loading';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { get } from 'lodash-es';
import { selectHouseRef } from '../../../selectors';
import { useAxios } from '../../../hooks';
import CreateNewByLotInvoices from './CreateNewByLotInvoices';
import CreateNewByInvoices from './CreateNewByInvoice';

export const CreateInvoices = () => {
  const [isByInvoice, setIsByInvoice] = useState();
  const { invoiceGroupID } = useParams();
  const houseRef = useSelector(selectHouseRef);
  const { data, isIdle, isLoading } = useAxios(
    () => `/app/house/${houseRef}/invoiceGroup/${invoiceGroupID}/applyCostPerLot`,
    [houseRef]
  );

  const handleViewState = (flag) => {
    if (flag === false) {
      setIsByInvoice(true);
    }
  };

  const getData = async () => {
    const invoiceData = get(data, 'data.data.invoiceBidders', []);
    if (invoiceData.length > 0) {
      handleViewState(invoiceData[0].applyCostPerLot);
    }
  };

  useEffect(() => {
    getData();
  }, [data]);

  if (isIdle || isLoading) {
    return (
      <ReactLoading className="loading-spinner" type="spin" color="black" />
    );
  }

  return (
    <>
      {isByInvoice ? <CreateNewByInvoices /> : <CreateNewByLotInvoices />}
    </>
  );
};
